import { makeStyles } from '@material-ui/styles'

export const useLatestMovementsStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    lineHeight: 1,
    fontWeight: 700,
    color: theme.palette.wallet.titleColor,
    fontSize: theme.typography.pxToRem(16),
  },
  seeMore: {
    flex: 0,
    padding: 0,
    lineHeight: 1,
    '&:focus': {
      outline: 0,
    },
    '& .MuiButton-label': {
      textDecoration: 'underline',
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.wallet.latestMovements.seeMoreColor,
    },
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.75),
  },
}))
